import { render, staticRenderFns } from "./userSelect.vue?vue&type=template&id=f849b84a&scoped=true&"
import script from "./userSelect.vue?vue&type=script&lang=js&"
export * from "./userSelect.vue?vue&type=script&lang=js&"
import style0 from "./userSelect.vue?vue&type=style&index=0&id=f849b84a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f849b84a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f849b84a')) {
      api.createRecord('f849b84a', component.options)
    } else {
      api.reload('f849b84a', component.options)
    }
    module.hot.accept("./userSelect.vue?vue&type=template&id=f849b84a&scoped=true&", function () {
      api.rerender('f849b84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/userSelect.vue"
export default component.exports